var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          attrs: {
            slot: "activator",
            color: "primary",
            icon: "",
            dark: "",
            small: ""
          },
          on: {
            click: function($event) {
              return _vm.navigate()
            }
          },
          slot: "activator"
        },
        [_c("v-icon", [_vm._v("navigate_before")])],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "8px" } }, [_vm._v(_vm._s(_vm.csv))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f520a99e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f520a99e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/ViewCSV.vue
// module id = null
// module chunks = 